import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-goregaon',
  templateUrl: './goregaon.component.html',
  styleUrls: ['./goregaon.component.scss']
})
export class GoregaonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  numb: any=[
    {
      n:'1',
      xy:'45px 0 0 30px'
    },
    {
      n:'2',
      xy:'98px 0 0 14px'
    },
    {
      n:'3',
      xy:'98px 0 0 48px'
    },
    {
      n:'4',
      xy:'45px 0 0 130px'
    },
    {
      n:'5',
      xy:'98px 0 0 114px'
    },
    {
      n:'6',
      xy:'98px 0 0 148px'
    },
    {
      n:'7',
      xy:'24px 0 0 238px'
    },
    {
      n:'8',
      xy:'24px 0 0 264px'
    },
    {
      n:'9',
      xy:'24px 0 0 288px'
    },
    {
      n:'10',
      xy:'24px 0 0 313px'
    },
    {
      n:'11',
      xy:'24px 0 0 338px'
    },
    {
      n:'12',
      xy:'99px 0 0 238px'
    },
    {
      n:'13',
      xy:'99px 0 0 264px'
    },
    {
      n:'14',
      xy:'99px 0 0 288px'
    },
    {
      n:'15',
      xy:'99px 0 0 313px'
    },
    {
      n:'16',
      xy:'99px 0 0 338px'
    },
    {
      n:'17',
      xy:'36px 0 0 437px'
    },
    {
      n:'18',
      xy:'margin:87px 0 0 437px'
    },
    {
      n:'19',
      xy:'29px 0 0 486px'
    },
    {
      n:'20',
      xy:'29px 0 0 540px'
    },
    {
      n:'21',
      xy:'58px 0 0 486px'
    },
    {
      n:'22',
      xy:'58px 0 0 540px'
    },
    {
      n:'23',
      xy:'159px 0 0 476px'
    },
    {
      n:'24',
      xy:'226px 0 0 104px'
    },
    {
      n:'25',
      xy:'226px 0 0 144px'
    },
    {
      n:'26',
      xy:'226px 0 0 188px'
    },
    {
      n:'27',
      xy:'226px 0 0 234px'
    },
    {
      n:'28',
      xy:'226px 0 0 278px'
    },
    {
      n:'29',
      xy:'226px 0 0 325px'
    },
    {
      n:'30',
      xy:'226px 0 0 370px'
    },
    {
      n:'31',
      xy:'273px 0 0 104px'
    },
    {
      n:'32',
      xy:'273px 0 0 144px'
    },
    {
      n:'33',
      xy:'273px 0 0 188px'
    },
    {
      n:'34',
      xy:'273px 0 0 234px'
    },
    {
      n:'35',
      xy:'273px 0 0 278px'
    },
    {
      n:'36',
      xy:'273px 0 0 325px'
    },
    {
      n:'37',
      xy:'273px 0 0 370px'
    },
    {
      n:'38',
      xy:'337px 0 0 104px'
    },
    {
      n:'39',
      xy:'337px 0 0 144px'
    },
    {
      n:'40',
      xy:'337px 0 0 188px'
    },
    {
      n:'41',
      xy:'337px 0 0 234px'
    },
    {
      n:'42',
      xy:'337px 0 0 278px'
    },
    {
      n:'43',
      xy:'337px 0 0 325px'
    },
    {
      n:'44',
      xy:'337px 0 0 370px'
    },
    {
      n:'45',
      xy:'383px 0 0 104px'
    },
    {
      n:'46',
      xy:'383px 0 0 144px'
    },
    {
      n:'47',
      xy:'383px 0 0 188px'
    },
    {
      n:'48',
      xy:'383px 0 0 234px'
    },
    {
      n:'49',
      xy:'383px 0 0 278px'
    },
    {
      n:'50',
      xy:'383px 0 0 325px'
    },
    {
      n:'51',
      xy:'383px 0 0 370px'
    },
    {
      n:'52',
      xy:'449px 0 0 104px'
    },
    {
      n:'53',
      xy:'449px 0 0 144px'
    },
    {
      n:'54',
      xy:'449px 0 0 188px'
    },
    {
      n:'55',
      xy:'449px 0 0 234px'
    },
    {
      n:'56',
      xy:'449px 0 0 278px'
    },
    {
      n:'57',
      xy:'449px 0 0 325px'
    },
    {
      n:'58',
      xy:'449px 0 0 370px'
    },
    {
      n:'59',
      xy:'494px 0 0 104px'
    },
    {
      n:'60',
      xy:'494px 0 0 144px'
    },
    {
      n:'61',
      xy:'494px 0 0 188px'
    },
    {
      n:'62',
      xy:'494px 0 0 234px'
    },
    {
      n:'63',
      xy:'494px 0 0 278px'
    },
    {
      n:'64',
      xy:'494px 0 0 325px'
    },
    {
      n:'65',
      xy:'494px 0 0 370px'
    },
    {
      n:'66',
      xy:'293px 0 0 465px'
    },
    {
      n:'67',
      xy:'293px 0 0 491px'
    },
    {
      n:'68',
      xy:'339px 0 0 465px'
    },
    {
      n:'69',
      xy:'339px 0 0 491px'
    },
    {
      n:'70',
      xy:'368px 0 0 465px'
    },
    {
      n:'71',
      xy:'368px 0 0 491px'
    },
    {
      n:'72',
      xy:'362px 0 0 544px'
    },
    {
      n:'73',
      xy:'362px 0 0 567px'
    },
    {
      n:'74',
      xy:'414px 0 0 465px'
    },
    {
      n:'75',
      xy:'414px 0 0 491px'
    },
    {
      n:'76',
      xy:'408px 0 0 544px'
    },
    {
      n:'77',
      xy:'408px 0 0 567px'
    },
    {
      n:'78',
      xy:'443px 0 0 465px'
    },
    {
      n:'79',
      xy:'443px 0 0 491px'
    },
    {
      n:'80',
      xy:'437px 0 0 544px'
    },
    {
      n:'81',
      xy:'437px 0 0 567px'
    },
    {
      n:'82',
      xy:'489px 0 0 465px'
    },
    {
      n:'83',
      xy:'489px 0 0 491px'
    },
    {
      n:'84',
      xy:'482px 0 0 544px'
    },
    {
      n:'85',
      xy:'482px 0 0 567px'
    },
    {
      n:'86',
      xy:'699px 0 0 104px'
    },
    {
      n:'87',
      xy:'699px 0 0 144px'
    },
    {
      n:'88',
      xy:'699px 0 0 188px'
    },
    {
      n:'89',
      xy:'699px 0 0 234px'
    },
    {
      n:'90',
      xy:'699px 0 0 278px'
    },
    {
      n:'91',
      xy:'699px 0 0 325px'
    },
    {
      n:'92',
      xy:'699px 0 0 370px'
    },
    {
      n:'93',
      xy:'763px 0 0 104px'
    },
    {
      n:'94',
      xy:'763px 0 0 144px'
    },
    {
      n:'95',
      xy:'763px 0 0 188px'
    },
    {
      n:'96',
      xy:'763px 0 0 234px'
    },
    {
      n:'97',
      xy:'763px 0 0 278px'
    },
    {
      n:'98',
      xy:'763px 0 0 325px'
    },
    {
      n:'99',
      xy:'763px 0 0 370px'
    },
    {
      n:'100',
      xy:'810px 0 0 104px'
    },
    {
      n:'101',
      xy:'810px 0 0 144px'
    },
    {
      n:'102',
      xy:'810px 0 0 188px'
    },
    {
      n:'103',
      xy:'810px 0 0 234px'
    },
    {
      n:'104',
      xy:'810px 0 0 278px'
    },
    {
      n:'105',
      xy:'810px 0 0 325px'
    },
    {
      n:'106',
      xy:'810px 0 0 370px'
    },
    {
      n:'107',
      xy:'874px 0 0 104px'
    },
    {
      n:'108',
      xy:'874px 0 0 144px'
    },
    {
      n:'109',
      xy:'874px 0 0 188px'
    },
    {
      n:'110',
      xy:'874px 0 0 234px'
    },
    {
      n:'111',
      xy:'874px 0 0 278px'
    },
    {
      n:'112',
      xy:'874px 0 0 325px'
    },
    {
      n:'113',
      xy:'874px 0 0 370px'
    },
    {
      n:'114',
      xy:'920px 0 0 104px'
    },
    {
      n:'115',
      xy:'920px 0 0 144px'
    },
    {
      n:'116',
      xy:'920px 0 0 188px'
    },
    {
      n:'117',
      xy:'920px 0 0 234px'
    },
    {
      n:'118',
      xy:'920px 0 0 278px'
    },
    {
      n:'119',
      xy:'920px 0 0 325px'
    },
    {
      n:'120',
      xy:'920px 0 0 370px'
    },
    {
      n:'121',
      xy:'985px 0 0 104px'
    },
    {
      n:'122',
      xy:'985px 0 0 144px'
    },
    {
      n:'123',
      xy:'985px 0 0 188px'
    },
    {
      n:'124',
      xy:'985px 0 0 234px'
    },
    {
      n:'125',
      xy:'985px 0 0 278px'
    },
    {
      n:'126',
      xy:'985px 0 0 325px'
    },
    {
      n:'127',
      xy:'985px 0 0 370px'
    },
    {
      n:'128',
      xy:'1032px 0 0 104px'
    },
    {
      n:'129',
      xy:'1032px 0 0 144px'
    },
    {
      n:'130',
      xy:'1032px 0 0 188px'
    },
    {
      n:'131',
      xy:'1032px 0 0 234px'
    },
    {
      n:'132',
      xy:'1032px 0 0 278px'
    },
    {
      n:'133',
      xy:'1032px 0 0 325px'
    },
    {
      n:'134',
      xy:'1032px 0 0 370px'
    }
  ];

}
